import { baseQuery } from './baseQuery';
import { type JsonDataItem } from '@g2u/ui-kit';

export const getSurvey = async ({ queryKey }: JsonDataItem) => {
  const { data } = await baseQuery(`survey/${queryKey[1]}`);

  return data;
};
